module.exports = __webpack_public_path__ + "img/arrow.9dc3e944.svg";